import { INQUIRY } from '@src/module/Inquiry/constants/api'

export const RECRUITMENT_INQUIRY = `/recruitment${INQUIRY}` as const
export const RECRUITMENT_INQUIRY_UPDATE_STATUS = `${RECRUITMENT_INQUIRY}update-status` as const
